import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, finalize, Observable, throwError } from "rxjs";
import { Router } from '@angular/router';
import { SpinnerService } from './services/spinner.service';
import { ManagerService } from "./services/manager.service";

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

    constructor(private router: Router, private managerService: ManagerService, private spinnerService: SpinnerService) { }

    requestsCount: number = 0;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!req.url.endsWith('ping=true')) {
            this.requestsCount++;
            this.spinnerService.show();
        }
        
        var accessToken = this.managerService.getToken();
        var authRequest = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${accessToken}`)
        });

        return next.handle(authRequest).pipe(
            finalize(() => {
                this.requestsCount--;

                if (this.requestsCount < 0)
                    this.requestsCount = 0;

                if (this.requestsCount == 0)
                    this.spinnerService.hide();
            }),
            catchError(error => {
                
                if (error.status == 401 && this.router.url != '/login') {
                    this.managerService.logout();
                    this.router.navigate(['/login']);
                }

                return throwError(error);
            })
        );
    }
}